import styles from '../styles/headers.module.scss';
import { ReactComponent as UndoIcon } from '@ui-kit/icons/undo.svg';
import MainButton from '@ui-kit/components/mainButton';
import { t } from '@base/utils/helpers';
import { useHistory } from 'react-router-dom';

function TopicHeader(props: { title: string; onClick: () => void }) {
  const history = useHistory();

  return (
    <div className={styles.mainHeader}>
      <div className={styles.header}>
        <div className={styles.info}>
          <button className={styles.btn} onClick={history.goBack}>
            <UndoIcon height={17} width={17} />
          </button>
          <p>{`topic > ${props.title}`}</p>
        </div>
        <MainButton className={styles.topicHeaderBtn} onClick={props.onClick}>
          {t('reply')}
        </MainButton>
      </div>
    </div>
  );
}

export default TopicHeader;
